module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.form.user != '') ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }, [_c('router-link', {
    staticClass: "fl-button grey",
    attrs: {
      "to": {
        path: '/users/list/'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "fl-button",
    attrs: {
      "disabled": _vm.is_save,
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])], 1), _vm._v(" "), _c('h1', [_vm._v("Felhasználó")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.shib) ? _c('select2ajax', {
    attrs: {
      "change": _vm.dnChange,
      "method": "post",
      "errors": _vm.errors,
      "url": 'user/searchdn/' + _vm.$root.user.apikey + '/' + _vm.form.user.element_id,
      "label": "Címtár",
      "id": "dn",
      "name": "dn"
    },
    model: {
      value: (_vm.form.user.dn),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "dn", $$v)
      },
      expression: "form.user.dn"
    }
  }) : _vm._e(), _vm._v(" "), _c('inputbox', {
    attrs: {
      "regexp_filter": "[a-zA-Z. öüóőúéáűíÖÜÓŐÚÉÁŰÍ0-9-]+",
      "id": "name",
      "label": "Név",
      "errors": _vm.errors,
      "name": "fullname"
    },
    model: {
      value: (_vm.form.user.name),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "name", $$v)
      },
      expression: "form.user.name"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "id": "email",
      "label": "Email",
      "errors": _vm.errors,
      "name": "email"
    },
    model: {
      value: (_vm.form.user.email),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "email", $$v)
      },
      expression: "form.user.email"
    }
  }), _vm._v(" "), (!_vm.shib) ? _c('inputbox', {
    attrs: {
      "id": "password",
      "label": "Jelszó",
      "errors": _vm.errors,
      "name": "password"
    },
    model: {
      value: (_vm.form.user.password),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "password", $$v)
      },
      expression: "form.user.password"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.shib) ? _c('inputbox', {
    attrs: {
      "id": "password_",
      "label": "Jelszó újra",
      "errors": _vm.errors,
      "name": "password_"
    },
    model: {
      value: (_vm.form.user.password_),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "password_", $$v)
      },
      expression: "form.user.password_"
    }
  }) : _vm._e(), _vm._v(" "), _c('toggle', {
    attrs: {
      "id": "filter_element",
      "label": "Csoportképzésnél szűrő",
      "name": "filter_element"
    },
    model: {
      value: (_vm.form.user.filter_element),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "filter_element", $$v)
      },
      expression: "form.user.filter_element"
    }
  }), _vm._v(" "), _c('toggle', {
    attrs: {
      "id": "barcode_period_fix",
      "label": "Vonalkód beállítás fix 24 óra",
      "name": "barcode_period_fix"
    },
    model: {
      value: (_vm.form.user.barcode_period_fix),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "barcode_period_fix", $$v)
      },
      expression: "form.user.barcode_period_fix"
    }
  }), _vm._v(" "), _c('select2', {
    attrs: {
      "multi": "true",
      "label": "Vonalkód igénylés csoportok",
      "name": "barcode_req_groups",
      "id": "barcode_req_groups",
      "options": _vm.usertype_groups
    },
    model: {
      value: (_vm.form.user.barcode_request_groups),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "barcode_request_groups", $$v)
      },
      expression: "form.user.barcode_request_groups"
    }
  }), _vm._v(" "), _c('select2', {
    attrs: {
      "multi": "true",
      "label": "Kártya csoportok",
      "name": "card_groups",
      "id": "card_groups",
      "options": _vm.card_groups
    },
    model: {
      value: (_vm.form.user.card_groups),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "card_groups", $$v)
      },
      expression: "form.user.card_groups"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('ulRight', {
    attrs: {
      "rootClass": "tree",
      "rights": _vm.form.rights
    }
  })], 1)])]) : _vm._e()])], 1), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProgressInfo', {
    attrs: {
      "show": _vm.is_save
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63397897"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/user.vue
// module id = 307
// module chunks = 0